import React from 'react'
import { Alert } from 'react-bootstrap'

export type PagePermissionAlertProps = {
  roleName: string
}

export const PagePermissionAlert = ({ roleName }: PagePermissionAlertProps) => {
  return (
    <div className="text-center m-t-lg">
      <Alert variant="danger">
        <Alert.Heading>You do not have a permission to view this page.</Alert.Heading>
        <p>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          Talk to your administrator about <b>'{roleName}'</b> permission.
        </p>
      </Alert>
    </div>
  )
}
